var GEO_DATA, Location, LocationBar, base, placeholderState, whichKeyAlias,
  slice = [].slice;

Location = require('../helper/m_location_helper');

GEO_DATA = require('../helper/m_searchbar_helper').GEO_DATA;

placeholderState = require('../helper/m_common').placeholderState;

whichKeyAlias = require('../common/m_keypress').whichKeyAlias;

module.exports = LocationBar = (function() {
  function LocationBar(arg) {
    var data, division, el, env, initialLocation, initialLocationData, ref, ref1;
    el = arg.el, env = arg.env;
    this.$el = el;
    this.env = env || 'desktop';
    this.previousValue = '';
    this.originalValue = '';
    this.hasDualSearch = (ref = Groupon.LS.experiments) != null ? ref['LS-2782-dual-search-header'] : void 0;
    this.$input = this.$el.find('#location, #ls-location');
    if (!Cookie.get('ell')) {
      if (division = Location.getDivision()) {
        Location.setELLCookie(division.lat + ',' + division.lng);
      }
    }
    initialLocation = Location.getInitialLocation();
    initialLocationData = Location.getInitialLocationData();
    data = {
      manual: false,
      city: (ref1 = Groupon.division) != null ? ref1.name : void 0
    };
    if (initialLocationData) {
      data = _.extend({}, data, _.pick.apply(_, [initialLocationData, 'lat', 'lng'].concat(slice.call(GEO_DATA))));
    }
    this.$input.data(data);
    if (!_.isBlank(initialLocation)) {
      placeholderState.set(this.$input, 'hide');
      this.$input.val(initialLocation);
      this.originalValue = initialLocation;
      switch (this.env) {
        case 'mobile':
          $('.t-division-link a').text(initialLocation);
      }
    }
    this.bind();
    switch (env) {
      case 'desktop':
        this.setupDesktop();
        break;
      case 'mobile':
        this.setupMobile();
    }
  }

  LocationBar.prototype.setLocation = LocationBar.val;

  LocationBar.prototype.val = function(value, options) {
    var currentVal, silent;
    if (options == null) {
      options = {};
    }
    silent = options.silent;
    if (value != null) {
      this.$input.val(value).removeClass('prompting');
      if (!silent) {
        return this.trigger('manual', value);
      }
    } else {
      currentVal = this.$input.val();
      if (_.isBlank(currentVal)) {
        return null;
      }
      return currentVal.trim();
    }
  };

  LocationBar.prototype.bind = function() {
    return this.$input.on({
      'focusin.location': (function(_this) {
        return function() {
          _this.storeLocation();
          if (_this.hasDualSearch) {
            _this.$input.attr('placeholder', _this.$input.val());
          }
          _this.$input.val('');
        };
      })(this),
      'focusout.location': (function(_this) {
        return function() {
          _this.storeLocation();
          _this.$input.val(_this.previousValue);
          if (_this.hasDualSearch) {
            _this.$input.attr('placeholder', null);
          }
          _this.$input.trigger('focusin.searchMobile');
        };
      })(this),
      'manual.location': (function(_this) {
        return function() {
          _this.$input.data({
            manual: true
          });
        };
      })(this),
      'input.location': (function(_this) {
        return function() {
          if (_this.$input.data('manual') !== true) {
            _this.$input.trigger('manual');
          }
        };
      })(this)
    });
  };

  LocationBar.prototype.restoreLocation = function() {
    var value;
    if ((value = this.originalValue).length) {
      return this.$input.val(value);
    }
  };

  LocationBar.prototype.storeLocation = function() {
    var value;
    if (!_.isBlank(value = this.$input.val())) {
      return this.previousValue = value;
    }
  };

  LocationBar.prototype.setupDesktop = function() {};

  LocationBar.prototype.setupMobile = function() {
    return this.$input.on({
      'keydown': (function(_this) {
        return function(e) {
          if (whichKeyAlias(e) === 'Enter') {
            return _this.$el.trigger('submit', 'manual');
          }
        };
      })(this)
    });
  };

  return LocationBar;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

_.extend(window.Groupon.Modules.SearchBar, {
  LocationBar: LocationBar
});

//# sourceMappingURL=data:application/json;base64,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
